var GEO_DATA, Location, LocationBar, base, placeholderState, whichKeyAlias,
  slice = [].slice;

Location = require('../helper/m_location_helper');

GEO_DATA = require('../helper/m_searchbar_helper').GEO_DATA;

placeholderState = require('../helper/m_common').placeholderState;

whichKeyAlias = require('../common/m_keypress').whichKeyAlias;

module.exports = LocationBar = (function() {
  function LocationBar(arg) {
    var data, division, el, env, initialLocation, initialLocationData, ref, ref1;
    el = arg.el, env = arg.env;
    this.$el = el;
    this.env = env || 'desktop';
    this.previousValue = '';
    this.originalValue = '';
    this.hasDualSearch = (ref = Groupon.LS.experiments) != null ? ref['LS-2782-dual-search-header'] : void 0;
    this.$input = this.$el.find('#location, #ls-location');
    if (!Cookie.get('ell')) {
      if (division = Location.getDivision()) {
        Location.setELLCookie(division.lat + ',' + division.lng);
      }
    }
    initialLocation = Location.getInitialLocation();
    initialLocationData = Location.getInitialLocationData();
    data = {
      manual: false,
      city: (ref1 = Groupon.division) != null ? ref1.name : void 0
    };
    if (initialLocationData) {
      data = _.extend({}, data, _.pick.apply(_, [initialLocationData, 'lat', 'lng'].concat(slice.call(GEO_DATA))));
    }
    this.$input.data(data);
    if (!_.isBlank(initialLocation)) {
      placeholderState.set(this.$input, 'hide');
      this.$input.val(initialLocation);
      this.originalValue = initialLocation;
      switch (this.env) {
        case 'mobile':
          $('.t-division-link a').text(initialLocation);
      }
    }
    this.bind();
    switch (env) {
      case 'desktop':
        this.setupDesktop();
        break;
      case 'mobile':
        this.setupMobile();
    }
  }

  LocationBar.prototype.setLocation = LocationBar.val;

  LocationBar.prototype.val = function(value, options) {
    var currentVal, silent;
    if (options == null) {
      options = {};
    }
    silent = options.silent;
    if (value != null) {
      this.$input.val(value).removeClass('prompting');
      if (!silent) {
        return this.trigger('manual', value);
      }
    } else {
      currentVal = this.$input.val();
      if (_.isBlank(currentVal)) {
        return null;
      }
      return currentVal.trim();
    }
  };

  LocationBar.prototype.bind = function() {
    return this.$input.on({
      'focusin.location': (function(_this) {
        return function() {
          _this.storeLocation();
          if (_this.hasDualSearch) {
            _this.$input.attr('placeholder', _this.$input.val());
          }
          _this.$input.val('');
        };
      })(this),
      'focusout.location': (function(_this) {
        return function() {
          _this.storeLocation();
          _this.$input.val(_this.previousValue);
          if (_this.hasDualSearch) {
            _this.$input.attr('placeholder', null);
          }
          _this.$input.trigger('focusin.searchMobile');
        };
      })(this),
      'manual.location': (function(_this) {
        return function() {
          _this.$input.data({
            manual: true
          });
        };
      })(this),
      'input.location': (function(_this) {
        return function() {
          if (_this.$input.data('manual') !== true) {
            _this.$input.trigger('manual');
          }
        };
      })(this)
    });
  };

  LocationBar.prototype.restoreLocation = function() {
    var value;
    if ((value = this.originalValue).length) {
      return this.$input.val(value);
    }
  };

  LocationBar.prototype.storeLocation = function() {
    var value;
    if (!_.isBlank(value = this.$input.val())) {
      return this.previousValue = value;
    }
  };

  LocationBar.prototype.setupDesktop = function() {};

  LocationBar.prototype.setupMobile = function() {
    return this.$input.on({
      'keydown': (function(_this) {
        return function(e) {
          if (whichKeyAlias(e) === 'Enter') {
            return _this.$el.trigger('submit', 'manual');
          }
        };
      })(this)
    });
  };

  return LocationBar;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

_.extend(window.Groupon.Modules.SearchBar, {
  LocationBar: LocationBar
});

//# sourceMappingURL=data:application/json;base64,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
